import { Badge, Icon, styleLink } from "orcs-design-system";
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";
import icons from "src/config/icons";
import GroupPropType from "src/custom-prop-types/group";
import { GroupTypesPropType } from "src/custom-prop-types/groupTypes";
import { getGroupBadgeVariant } from "src/util/group";
import { teamDetailsPath } from "src/util/routing";

import GroupHierarchyBreadcrumb from "../GroupHierarchyBreadcrumb";

const StyledRouterLink = styleLink(Link);

const StyledBadge = styled(Badge)`
  cursor: pointer;
`;

const BadgeLink = styled(StyledRouterLink)`
  display: inline-block;
  text-decoration: none !important;
  color: inherit !important;
  font-weight: inherit !important;
  font-size: inherit !important;
  &:hover {
    text-decoration: none !important;
    color: inherit !important;
  }
  &:focus {
    text-decoration: none !important;
    color: inherit !important;
  }
  &:visited {
    color: inherit !important;
  }
`;

const BadgeLinkContainer = styled.div`
  display: inline-block;
`;

const CustomIcon = styled(Icon)`
  line-height: 1;
  padding-right: 4px;

  svg {
    opacity: 0.5;
    transition: opacity 300ms ease-in-out;
    transition-delay: 250ms;
  }
  &:hover {
    svg {
      opacity: 1;
    }
  }
`;

const GroupBadge = ({ group, groupTypes, showBreadcrumbIcon = true }) => {
  const badgeContent = (
    <StyledBadge
      display="block"
      variant={getGroupBadgeVariant(group, groupTypes)}
      data-testid={`group-badge-${group.id}`}
    >
      {showBreadcrumbIcon && (
        <CustomIcon icon={icons.groupBreadcrumb} size="s" />
      )}
      {group.name}
    </StyledBadge>
  );

  const handleClick = (e) => {
    // Stop propagation to prevent interfering with parent click handlers
    // (e.g., org chart card selection). This allows the badge to navigate
    // to the team page without triggering parent element clicks.
    e.stopPropagation();
  };

  const teamPath = teamDetailsPath(group);

  return (
    <GroupHierarchyBreadcrumb group={group} useChildren>
      <BadgeLinkContainer onClick={handleClick}>
        <BadgeLink to={teamPath}>{badgeContent}</BadgeLink>
      </BadgeLinkContainer>
    </GroupHierarchyBreadcrumb>
  );
};

GroupBadge.propTypes = {
  group: GroupPropType.isRequired,
  groupTypes: GroupTypesPropType.isRequired,
  showBreadcrumbIcon: PropTypes.bool,
};

export default GroupBadge;
